import React, {useState, useEffect} from 'react';
import moment from 'moment';
import dayjs from 'dayjs';
import {removeUserAction} from '../../actions/profile.js';
//import {SnackBar, DialogWindow, CustomAvatar} from  './general';
//import {getAllBookings} from '../services/booking.js'
import { getItemOccupancy } from '../../services/products.js'
import TypeDropdown from "../../components/typeDropdown.js"
import DetailView from "./detailViewPopUp"
import { SquareRow } from './squareRow'
//import WeeklyBookPopup from './weeklyBookPopup.js';
import {IconButton, Card, Box, Paper, Stack, Badge, Typography} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const classes = {
    root: {
      width: '100%',
      height: '100%',
      position:'relative',
      maxHeight: 'calc(100vh - 100px)',
      overflowY: 'hidden',
      paddingTop:'20px'
    }
  };

  const fallsInDate = (dateToCheck, startDate, endDate) => {
    dateToCheck = moment(dateToCheck, 'DD-MM-YYYY')
    startDate = moment(startDate, 'DD-MM-YYYY')
    endDate = moment(endDate, 'DD-MM-YYYY')
    return dateToCheck.isBetween(startDate, endDate, undefined, '[]');
  }


  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

  const DatePickerComponent = ({isMobile, date, setDate}) => {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker sx={isMobile ? { width: 130 }: {}} disablePast label="Pick Date" format="DD-MM-YYYY" value={dayjs(date, "DD-MM-YYYY").subtract(1, 'days')} onChange={(newVal)=> {setDate(newVal.add(1,'days').format('DD-MM-YYYY'))}}/>
      </LocalizationProvider>
    );
  }

  const TableHeader = ({isMobile, decrementDate, incrementDate, date}) => {
    if (isMobile) {
      return (
      <Box sx={{display: "table", borderCollapse: "separate", marginBottom: 2, marginTop:2, borderSpacing: isMobile ? "0em 0em" : "10em 2em", width: '100%'}}>
          <Box sx={{display: "table-row"}}>
              <Box sx={{ display: "table-cell", textAlign:"center", verticalAlign: "middle", width: isMobile ? 100 : 250 }}></Box>
              <Box sx={{ display: "table-cell", textAlign:"center", verticalAlign: "middle"}}>
                <Box sx={{position: 'relative'}}>
                    <IconButton disabled={date === moment().add(1, 'days').format("DD-MM-YYYY")} onClick={decrementDate} sx={{position: 'absolute', top:0, left: 0}}>
                      <ChevronLeftIcon sx={{fontSize: 30}}/>
                    </IconButton>
                  <Typography>{moment(date, "DD-MM-YYYY").subtract(1, "days").format("DD-MM-YYYY (ddd)")}</Typography>
                  <IconButton onClick={incrementDate} sx={{position: 'absolute', top:0, right: 0}}>
                      <ChevronRightIcon sx={{fontSize: 30}} />
                    </IconButton>
                </Box>
              </Box>
          </Box>
        </Box>
      )
    }
    return (
      <Box sx={{display: "table", borderCollapse: "separate", borderSpacing: isMobile? "4px 0px" : "40px 20px", width: '100%'}}>
          <Box sx={{display: "table-row"}}>
              <Box sx={{ display: "table-cell", textAlign:"center", verticalAlign: "middle", width: isMobile ? 100 : 250 }}>
              </Box>
              <Box sx={{ display: "table-cell", textAlign:"center", verticalAlign: "middle"}}>
                <Box sx={{position: 'relative'}}>
                <IconButton disabled={date === moment().add(1, 'days').format("DD-MM-YYYY")} onClick={decrementDate} sx={{position: 'absolute', top:0, left: 0}}>
                  <ChevronLeftIcon sx={{fontSize: 30}}/>
                </IconButton>
                <Typography>{moment(date, "DD-MM-YYYY").subtract(1, "days").format("DD-MM-YYYY (ddd)")}</Typography>
                </Box>
              </Box>
              <Box sx={{ display: "table-cell", textAlign:"center", verticalAlign: "middle"}}>
                <Typography>{moment(date, "DD-MM-YYYY").format("DD-MM-YYYY (ddd)")}</Typography>
              </Box>
              <Box sx={{ display: "table-cell", textAlign:"center", verticalAlign: "middle"}}>
                <Box sx={{position: 'relative'}}>
                  <IconButton onClick={incrementDate} sx={{position: 'absolute', top:0, right: 0}}>
                    <ChevronRightIcon sx={{fontSize: 30}} />
                  </IconButton>
                  <Typography>{moment(date, "DD-MM-YYYY").add(1, "days").format("DD-MM-YYYY (ddd)")}</Typography>
                </Box>
              </Box>
          </Box>
        </Box>
    )
  }


const ProductRow = ({setSelectedProduct, setShowDetailPopup, isMobile, product, bookings, date}) => {
  if (isMobile) {
    const relventBookings = bookings.filter(booking => {
      return fallsInDate(moment(date, "DD-MM-YYYY").subtract(1 ,'days').format('DD-MM-YYYY')), moment(booking.from).format("DD-MM-YYYY"), moment(booking.to).format("DD-MM-YYYY")
    })
    return (
      <Box sx={{display: "table-row"}} onClick={()=>{setSelectedProduct(product); setShowDetailPopup(true)}}>
        <Box sx={{ display: "table-cell", textAlign:"center", verticalAlign: "middle", width: 50}}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <img src={product?.image?.thumb} height="50"/>
            <Typography sx={{fontSize: 12}}>{product.name}</Typography>
          </Stack>
        </Box>
        <Box sx={{ display: "table-cell", textAlign:"center", verticalAlign: "middle"}} >
          <Stack direction="column" spacing={0.25}>
              {product.itemsDetail.map(item => <SquareRow isMobile={isMobile} key={item._id} item={item._id} sku={item.sku} date={moment(date, "DD-MM-YYYY").subtract(1 ,'days').format('DD-MM-YYYY')} bookings={relventBookings}/>)}
          </Stack>
        </Box>
      </Box>
    )
  } else {
    let firstArr = [],
        secondArr = [],
        thirdArr = [];
        bookings.forEach((booking)=>{
          if (fallsInDate(moment(date, "DD-MM-YYYY").subtract(1 ,'days').format('DD-MM-YYYY')), moment(booking.from).format("DD-MM-YYYY"), moment(booking.to).format("DD-MM-YYYY")) {
            firstArr.push(booking)
          }
          if (fallsInDate(date,  moment(booking.from).format("DD-MM-YYYY"), moment(booking.to).format("DD-MM-YYYY"))) {
            secondArr.push(booking)
          }
          if (fallsInDate(moment(date, "DD-MM-YYYY").add(1 ,'days').format('DD-MM-YYYY')),  moment(booking.from).format("DD-MM-YYYY"), moment(booking.to).format("DD-MM-YYYY")) {
            thirdArr.push(booking)
          }
        })
    return (
        <Box sx={{display: "table-row"}}>
            <Box sx={{ display: "table-cell", textAlign:"center", verticalAlign: "middle", width: 250}}>
                <Stack direction="row" alignItems="center" spacing={2}>
                    <img src={product?.image?.thumb} height="50"/>
                    <Typography>{product.name}</Typography>
                </Stack>
            </Box>
            <Box sx={{ display: "table-cell", textAlign:"center", verticalAlign: "middle"}}>
                <Stack direction="column" spacing={0.25}>
                    {product.itemsDetail.map(item => <SquareRow key={item._id} item={item._id} sku={item.sku} date={moment(date, "DD-MM-YYYY").subtract(1 ,'days').format('DD-MM-YYYY')} bookings={firstArr}/>)}
                </Stack>
            </Box>
            <Box sx={{ display: "table-cell", textAlign:"center", verticalAlign: "middle"}} >
                <Stack direction="column" spacing={0.25}>
                    {product.itemsDetail.map(item => <SquareRow key={item._id} item={item._id} sku={item.sku} date={date} bookings={secondArr}/>)}
                </Stack>
            </Box>
            <Box sx={{ display: "table-cell", textAlign:"center", verticalAlign: "middle"}}>
                <Stack direction="column" spacing={0.25}>
                    {product.itemsDetail.map(item => <SquareRow key={item._id} item={item._id} sku={item.sku} date={moment(date, "DD-MM-YYYY").add(1, 'days').format('DD-MM-YYYY')} bookings={thirdArr}/>)}
                </Stack>
            </Box>
        </Box>
    )
  }

};

export default function BookingList(props) {
    const [bookings, setBookings] = useState([])
    const [products, setProducts] = useState([])
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedBooking, setSelectedBooking] = useState();
    const [date, setDate] = useState()
    const [selectedProduct, setSelectedProduct] = useState();
    const [showDetailPopup, setShowDetailPopup] = useState(false)
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [selectedType, setSelectedType] = useState('All')
    const isMobile = windowDimensions.width < 500 ? true : false  
  
    useEffect(()=>{
        const getProductData = async () => {
          try {
            const data = await getItemOccupancy(date, props.selectedType || "All");
            setProducts(data.products)
            setBookings(data.bookings)
          } catch (e) {
            if (e.status === 401) {
              dispatch(removeUserAction())
              navigate('/');
            }
          }
        }
        if (date) {
          getProductData()
        }
        
    }, [date])

    const closeDetailPopUp = () => {
      setShowDetailPopup(false)
    }
    const incrementDate = () => {
      setDate(moment(date, "DD-MM-YYYY").add(1, 'days').format("DD-MM-YYYY"))
    }
    const decrementDate = () => {
      setDate(moment(date, "DD-MM-YYYY").subtract(1, 'days').format("DD-MM-YYYY"))
    }
    useEffect(()=>{
        setDate(moment().add(1, 'days').format("DD-MM-YYYY"))
    }, [])
    return (
      <Paper sx={classes.root}>
        <Box sx={{ ml: 2, mr: 2, display: 'flex', flexDirection: 'row' }}>
          <Box sx={{  mr: 2 }}>
            <TypeDropdown isMobile={isMobile} selectedType={selectedType} setSelectedType={setSelectedType}/>
          </Box>
          <Box sx={{ mr: 2 }}>
            <DatePickerComponent isMobile={isMobile} date={date} setDate={setDate}/>
          </Box>
        </Box>
        <TableHeader
          isMobile={isMobile}
          incrementDate={incrementDate}
          decrementDate={decrementDate}
          date={date}
        />
        <Box sx={{ height: '85%', overflow: 'scroll'}}>
          <Box sx={{display: "table", borderCollapse: "separate", borderSpacing: isMobile? "4px 0px" : "40px 20px", width: '100%'}}>
            {products.filter((product)=> selectedType ==='All' ? true : selectedType === product.type).map(product => <ProductRow setShowDetailPopup={setShowDetailPopup} setSelectedProduct={setSelectedProduct} isMobile={isMobile} key={product._id} product={product} date={date} bookings={bookings}/>)}
          </Box>
        </Box>
        <DetailView
          open={showDetailPopup}
          selectedProduct={selectedProduct}
          handleClose={closeDetailPopUp}
          date={isMobile? moment(date, "DD-MM-YYYY").subtract(1 ,'days').format('DD-MM-YYYY') : date}
          bookings={bookings}
        />
      </Paper>
    );
  }